
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import BusinessFeatures from './business-opportunity/BusinessFeatures';
import RevenueScenarios from './business-opportunity/RevenueScenarios';
import RevenueSplitSection from './business-opportunity/RevenueSplitSection';
import GetStartedSection from './business-opportunity/GetStartedSection';
import BusinessUseCases from './business-opportunity/BusinessUseCases';
import BusinessCTA from './business-opportunity/BusinessCTA';
import { scenarios, revenueSplits } from './business-opportunity/data';

const BusinessOpportunity: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-primary-blue mb-3">Launch Your Referral Business</h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            Build a profitable referral business with our white-label platform. Earn recurring revenue by reselling our referral program to businesses in your network.
          </p>
        </div>

        <div className="mb-16">
          <Card className="shadow-lg border-t-4 border-primary-blue">
            <CardHeader className="pb-2">
              <CardTitle className="text-2xl text-primary-blue">Referral Business Opportunity</CardTitle>
            </CardHeader>
            <CardContent>
              {/* Business Features Section */}
              <BusinessFeatures />

              {/* Revenue Scenarios Section */}
              <RevenueScenarios scenarios={scenarios} />

              {/* Revenue Split Section */}
              <RevenueSplitSection revenueSplits={revenueSplits} />

              {/* Get Started Section */}
              <GetStartedSection />
            </CardContent>
          </Card>
        </div>

        {/* Business Use Cases Section */}
        <BusinessUseCases />

        {/* Final CTA Section */}
        <BusinessCTA />
      </div>
    </section>
  );
};

export default BusinessOpportunity;
